// extracted by mini-css-extract-plugin
export default {"page":"PageList_page__Cp8fA"};